/**
 * Resolves a carousel image URL to a concrete image path.
 *
 * - Legacy URLs (with extension like .webp/.jpg/.png) are returned as-is.
 * - Responsive base URLs (no extension) get the requested variant appended.
 */
export function resolveImageUrl(
  url: string | undefined | null,
  variant: "sm" | "md" | "lg" = "lg"
): string {
  if (!url) return "";
  if (/\.\w{3,4}$/.test(url)) return url;
  return `${url}-${variant}.webp`;
}

/**
 * Check if a URL is a responsive base URL (no file extension).
 */
export function isResponsiveUrl(url: string | undefined | null): boolean {
  if (!url) return false;
  return !/\.\w{3,4}$/.test(url);
}

/**
 * Build a srcSet string for responsive base URLs.
 * Returns empty string for legacy URLs.
 */
export function buildSrcSet(url: string | undefined | null): string {
  if (!url || !isResponsiveUrl(url)) return "";
  return `${url}-sm.webp 828w, ${url}-md.webp 1200w, ${url}-lg.webp 1920w`;
}
